export default "__VITE_ASSET__CUocHmlL__"